export default __webpack_public_path__ + "static/media/Company.2b61d465.svg";